import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/side-nav/logout/logout.component';
import { EntryGuard } from './core/auth/entry.guard';

export const routes: Routes = [
  {
    path: '',
    canMatch: [() => EntryGuard()],
    children: [
      {
        path: 'dashboard',
        component: HomeComponent,
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./components/admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'arrive-depart',
        loadChildren: () =>
          import('./components/operations/operations.module').then(
            (m) => m.OperationsModule,
          ),
      },
      {
        path: 'revenue-recovery',
        loadChildren: () =>
          import('./components/revenue-recovery/revenue-recovery.module').then(
            (m) => m.RevenueRecoveryModule,
          ),
      },
      {
        path: 'inbound',
        loadChildren: () =>
          import('./components/inbound/inbound.module').then(
            (m) => m.InboundModule,
          ),
      },
      {
        path: 'position-operations',
        loadChildren: () =>
          import('./components/position-operations/position-operations.module').then(
            (m) => m.PositionOperationsModule,
          ),
      },
      {
        path: 'customer',
        loadChildren: () =>
          import('./components/customer/customer.routes').then(
            (mod) => mod.CUSTOMER_ROUTES,
          ),
      },
      {
        path: 'sci',
        loadChildren: () =>
          import('./SCI/components/sci.routes').then((mod) => mod.SCI_ROUTES),
      },
      {
        path: 'messaging',
        loadChildren: () =>
          import('./components/messaging/messaging.module').then(
            (m) => m.MessagingModule,
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./components/reports/reports.module').then(
            (m) => m.ReportsModule,
          ),
      },
      {
        path: 'logout',
        component: LogoutComponent,
      },
      {
        path: 'auth',
        component: MsalRedirectComponent,
      },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: '',
        redirectTo: 'dashboard',
      },
      { path: '**', redirectTo: 'dashboard' },
    ],
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'auth',
    component: MsalRedirectComponent,
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
